import React, { createContext, useContext, useMemo } from 'react';
import { useTimeIntervalsQuery } from '../../api/timeIntervals';
import { TimeIntervalsController } from './core/index.';

const Context = createContext();

export const useTimeIntervals = () => useContext(Context);

export const TimeIntervalsProvider = ({ children }) => {
  const { data } = useTimeIntervalsQuery();

  const controller = useMemo(
    () => new TimeIntervalsController(Array.isArray(data) ? data : []),
    [data]
  );

  return <Context.Provider value={controller}>{children}</Context.Provider>;
};
